(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TABLET_QUERY = '(min-width: 750px) and (max-width: 989px)';

    function initCarousel(root) {
      var track = root.querySelector('[data-menu-track]');
      var dotsWrap = root.querySelector('[data-menu-dots]');
      if (!track || !dotsWrap) return;

      var items = Array.prototype.slice.call(track.children);
      if (items.length < 2) return;

      var mq = window.matchMedia(TABLET_QUERY);
      var dots = [];
      var built = false;

      function buildDots() {
        if (built) return;
        dotsWrap.innerHTML = '';
        items.forEach(function (item, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'diesel-footer__menu-dot';
          dot.setAttribute('aria-label', 'Go to menu ' + (i + 1));
          dot.addEventListener('click', function () {
            var target = items[i];
            track.scrollTo({
              left: target.offsetLeft - track.offsetLeft,
              behavior: 'smooth'
            });
          });
          dotsWrap.appendChild(dot);
        });
        dots = Array.prototype.slice.call(dotsWrap.children);
        built = true;
      }

      function activeIndex() {
        var trackRect = track.getBoundingClientRect();
        var closest = 0;
        var closestDist = Infinity;
        items.forEach(function (item, i) {
          var rect = item.getBoundingClientRect();
          var dist = Math.abs(rect.left - trackRect.left);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        return closest;
      }

      function setActive(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          if (mq.matches) setActive(activeIndex());
          ticking = false;
        });
      }, { passive: true });

      function refresh() {
        if (mq.matches) {
          buildDots();
          dotsWrap.style.display = 'flex';
          setActive(activeIndex());
        } else if (built) {
          dotsWrap.style.display = 'none';
        }
      }

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', refresh);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(refresh);
      }
      window.addEventListener('resize', refresh);

      refresh();
    }

    function init() {
      document.querySelectorAll('[data-menu-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
